import type { Banner } from '~/types'

export type BannerImageVariant = 'desktop' | 'mobile'

export type BannerImageInfo = {
  src: string
  width: number | null
  height: number | null
  variant: BannerImageVariant
}

export function bannerMediaType(banner: Banner): 'image' | 'video' {
  return banner.mediaType === 'video' ? 'video' : 'image'
}

export function bannerHasImage(banner: Banner): boolean {
  return Boolean(banner.image || banner.mobileImage)
}

export function bannerHasMedia(banner: Banner): boolean {
  return bannerHasImage(banner)
}

export function getBannerImageInfo(banner: Banner, isMobile: boolean): BannerImageInfo | null {
  if (isMobile && banner.mobileImage) {
    return {
      src: banner.mobileImage,
      width: banner.mobileImageWidth ?? null,
      height: banner.mobileImageHeight ?? null,
      variant: 'mobile',
    }
  }

  if (banner.image) {
    return {
      src: banner.image,
      width: banner.imageWidth ?? null,
      height: banner.imageHeight ?? null,
      variant: 'desktop',
    }
  }

  if (banner.mobileImage) {
    return {
      src: banner.mobileImage,
      width: banner.mobileImageWidth ?? null,
      height: banner.mobileImageHeight ?? null,
      variant: 'mobile',
    }
  }

  return null
}

export function bannerImageProbeKey(bannerId: number, variant: BannerImageVariant): string {
  return `${bannerId}-${variant}`
}
